export default __webpack_public_path__ + "static/media/environment.cbb35ae9.svg";